import { ProductSubscriptionReportRequestDTO } from '@iota/inh-core-v1-management-client';
import { FoyerCaseExportDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';
import { ProductSubscriptionReportType } from 'src/app/administration/product-subscription-report/report-type';
import { ErrorResponse } from '../../shared/constants-and-enums/error-response';

export enum ReportingActionTypes {
    GenerateProductSubscriptionReport = '[Reporting] GenerateProductSubscriptionReport',
    CreateFoyerCaseExport = '[Reporting] Create Foyer Case Export',

    ReportActionSuccess = '[Reporting] ReportActionSuccess',
    ReportActionFailure = '[Reporting] ReportActionFailure',
    ReportActionNoContent = '[Reporting] ReportNoContent',
    ResetReportActionData = '[Reporting] ResetReportActionData'
}

export const GenerateProductSubscriptionReport = createAction(
    ReportingActionTypes.GenerateProductSubscriptionReport,
    props<{ request: ProductSubscriptionReportRequestDTO; reportType: ProductSubscriptionReportType }>()
);
export const CreateFoyerCaseExport = createAction(
    ReportingActionTypes.CreateFoyerCaseExport,
    props<{
        request: FoyerCaseExportDTO;
    }>()
);
export const ReportActionSuccess = createAction(ReportingActionTypes.ReportActionSuccess);
export const ReportActionNoContent = createAction(ReportingActionTypes.ReportActionNoContent);
export const ReportActionFailure = createAction(ReportingActionTypes.ReportActionFailure, props<{ error: ErrorResponse }>());
export const ResetReportActionData = createAction(ReportingActionTypes.ResetReportActionData);
